import { ScanLogType } from "../../app.enums";
import { modalMessage } from "../../app.modal-messages";
import { MilkBottleModel } from "../../models/milk.model";
import { ScanMilkBottleValidationError } from "./scan-validation-error";
import { IScanValidation } from "./scan-validation.model";

export function RejectDischarged() {
	return function (
		target: any,
		propertyKey: string,
		descriptor: PropertyDescriptor
	) {
		const originalMethod = descriptor.value;

		descriptor.value = function (...args: IScanValidation[]) {
			const [obj] = args;

			if (obj.milkBottle instanceof MilkBottleModel) {
				if (obj.milkBottle && obj.milkBottle.dischargeDate) {
					throw new ScanMilkBottleValidationError(
						ScanLogType.Milk_Bottle_Discharged,
						modalMessage.milk_discharged(obj.milkBottle)
					);
				}
			}

			return originalMethod.apply(this, args);
		};
	};
}
